/**
 * Generates the storage path for a study video
 * @param moduleId - The module ID
 * @param topic - The topic name
 * @param filename - The filename (should include extension)
 * @returns The storage path for the study video
 */
export default function getStudyVideoPath(moduleId: string, topic: string, filename: string): string {
  return `studies/${moduleId}/${topic}/videos/${filename}`;
}
